<template>
  <b-table
    striped
    hover
    :items="sheetData"
    :fields="sheetFields"
    responsive="sm"
    head-variant="light"
    caption-top
    class="text-right mb-5"
  >
    <template v-slot:table-caption
      ><h2 class="h5 text-white text-center bg-dark my-0 py-3">
        {{ stockID }}
        {{ companyName }}_{{ sheetName }}
        <span class="h6">單位：{{ unit }}</span>
      </h2>
    </template>
    <template v-slot:head()="scope">
      <div class="text-nowrap">
        {{ scope.column === "subTitle" ? "期別" : scope.column }}
      </div>
      <div class="text-nowrap">{{ scope.label }}</div>
    </template>
    <template v-if="isMultipleUnit" v-slot:cell(subTitle)="{ item }">
      {{
        item.subTitle === "每股EBIDTA" ||
        item.subTitle === "近四季每股EPS" ||
        item.subTitle === "每股EPS"
          ? `${item.subTitle}(元)`
          : `${item.subTitle}(％)`
      }}
    </template>
  </b-table>
</template>

<script>
export default {
  props: {
    sheetData: {
      type: Array
    },
    sheetFields: {
      type: Array
    },
    sheetName: {
      type: String,
      default: "資產負債表_年"
    },
    companyName: {
      type: String,
      default: "台積電"
    },
    stockID: {
      type: [String, Number],
      default: 2330
    },
    unit: {
      type: String,
      default: "百萬"
    },
    isMultipleUnit: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    tdClass(value) {
      return Math.sign(value) === -1 && "text-danger";
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .b-table-sticky-column {
  text-align: left;
}
::v-deep .table-b-table-default {
  text-align: left;
}
</style>
